import { defineMessages } from 'react-intl';

export default defineMessages({
  voting: 'Voting',
  executed: 'Executed',
  failed: 'Failed',
  queued: 'Queued',
  pending: 'Pending',
  canceled: 'Canceled',
  passed: 'Passed',
  expired: 'Expired',
});
